import { render, staticRenderFns } from "./QueueCard.vue?vue&type=template&id=69a8a788&scoped=true&"
import script from "./QueueCard.vue?vue&type=script&lang=js&"
export * from "./QueueCard.vue?vue&type=script&lang=js&"
import style0 from "./QueueCard.vue?vue&type=style&index=0&id=69a8a788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a8a788",
  null
  
)

export default component.exports